import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { FormErrorMessageSpan, InputMintDiv } from "views/common-styled-components";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getDefaultHeaders, post } from "__utils/ajax-wrapper";

import resolveURLParams from "__utils/url-params-resolver";
import { ENDPOINTS } from "constants/endpoints";
import useFlashToggler from "hooks/use-flash-toggler";
import { getEncryptedUserId, isBtoCFlow } from "__utils/common-utils";
import { AjaxError, AjaxResponse } from "rxjs/ajax";
import { fetchGetCurrentUser } from "views/login/login.actions";

import ConfirmationModal from "components/confirmation-modal";
import styled from "styled-components";
import { CommonStyledComponentProps } from "__utils/type";
import { SuccessButton, SuccessButtonWhiteBg } from "components/button";
import { propsToJS } from "__utils/immutable-to-js";
import RiskProfileViewSelector from "../../risk-profile/risk-profile.selector";

import OtpScreen from "images/otp-screen.png";

const CenterButton = styled.div`
  text-align: center;
`;
const SuccessBtn = styled(SuccessButton)<CommonStyledComponentProps>`
  width: 150px;
  font-size: 14px;
`;

interface OtpProps {
  onSuccessCallBack: Function
}

const OtpPopup: React.FC<OtpProps> = ({onSuccessCallBack}) => {
  const flash = useFlashToggler();
  const dispatch = useDispatch();
  const history = useHistory();
  const [disableBtn, setDisableBtn] = useState("");

  const { riskProfileResult } = propsToJS(useSelector(RiskProfileViewSelector));


  const formState = useForm({ mode: 'onChange' });
    const { register, handleSubmit, errors } = formState;

  const otpScreenHandler = (data: any) => {
    if (!data.otp) {
      flash.error("Please enter OTP.");
    } else if (data.otp?.length !== 6) {
      flash.error("Please enter correct OTP.");
    } else {
      data?.otp &&
        post(
          resolveURLParams(
            ENDPOINTS.POST_VERIFY_OTP,
            { otp: data.otp },
            { ucc: getEncryptedUserId() }
          ),
          null,
          getDefaultHeaders(),
          true
        ).subscribe(
          (response: AjaxResponse | AjaxError) => {
            if (response?.response?.meta?.message === "success") {
              onSuccessCallBack();
              dispatch(fetchGetCurrentUser());
              history.push(`/profile/mandates/setup-mandate?flowType=checkout&ucc=${getEncryptedUserId()}`);
            } else if (response?.response?.meta?.message === "failure") {
              flash.error(response?.response?.meta?.error + ".");
            }
          },
          (error: AjaxError) => {
            flash.error("Something went wrong. Please try again later......");
          }
        );
    }
  };

  const resendOTPHandler = () => {
    post(
        resolveURLParams(
          ENDPOINTS.POST_SEND_OTP,
          { isBtoCFlow: isBtoCFlow() },
          { ucc: getEncryptedUserId() }
        ),
        {},
        getDefaultHeaders(),
        true
      ).subscribe(
        (response: AjaxResponse | AjaxError) => {
          if (response?.response?.meta?.message === "success") {
            flash.success(response.response.data);
            setDisableBtn("disabledBtn");
            setTimeout(() => {
              setDisableBtn("");
            }, 30000);
          } else if (response?.response?.meta?.message === "failure") {
            flash.error('Failed to send OTP.');
          }
        },
        (error: AjaxError) => {
          flash.error("Something went wrong. Please try again later.");
        }
      );
  };

  useEffect(() => {
    resendOTPHandler()
  }, []);

  return (
    <>
      <ConfirmationModal
        title=""
        closable={false}
        modalBody={
          <>
            <CenterButton className="mb20">
              <img src={OtpScreen} alt="" style={{ verticalAlign: "middle" }} />
            </CenterButton>
            <p>
              To complete the account opening process, please authenticate by
              entering the OTP received on your registered mobile number or
              email.
            </p>{" "}
            <br />
            <form
              key={2}
              name="otpDetailForm"
              onSubmit={handleSubmit(otpScreenHandler)}
            >
              <InputMintDiv>
                <label htmlFor="otp">Enter OTP</label>
                <br />
                <input
                  name="otp"
                  type="number"
                  placeholder="******"
                  ref={register({})}
                />
                {errors?.otp ? (
                  <FormErrorMessageSpan>
                    {errors.otp.message}
                  </FormErrorMessageSpan>
                ) : null}
              </InputMintDiv>
              <div className="mt20 pb24" style={{ textAlign: "right" }}>
                <SuccessButtonWhiteBg
                  className={disableBtn}
                  type="button"
                  style={{ width: "110px" }}
                  onClick={resendOTPHandler}
                >
                  Resend OTP
                </SuccessButtonWhiteBg>
                <SuccessBtn type="submit">Verify OTP</SuccessBtn>
              </div>
            </form>
          </>
        }
      />
    </>
  );
};
export default OtpPopup;
